import { Helmet } from "react-helmet";
import styles from "./FullBleedSetup.module.css";

/**
 * Shared base component to fill screen
 */
type FullBleedSetupProps = {
  children: React.ReactNode;
};

export default function FullBleedSetup({ children }: FullBleedSetupProps) {
  return (
    <div className={`full-bleed-setup ${styles.setup}`}>
      <Helmet>
        <meta
          name="viewport"
          key="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no, viewport-fit=cover"
        />
      </Helmet>
      {children}
    </div>
  );
}
